<template>
  <ServiceLayout
    icon="notext-stargroup.png"
    title="StarGroup"
    description="Cocok untuk anda yang ingin berpergian bersama keluarga besar atau teman-teman dengan kapasitas mulai dari 9-13 orang (hanya berlaku untuk perjalanan dalam kota)."
    :extra_hour="1"
    :tariffs="stargroup_tariffs"
    :lists="stargroup_list"
  />
</template>

<script>
import ServiceLayout from '@/components/ServiceLayout'

export default {
  name: 'StarGroup',
  components: {
    'ServiceLayout': ServiceLayout
  },
  data () {
    return {
      stargroup_list: [
        {
          icon: 'kapasitas-stargroup.png',
          icon_position: 'left',
          title: 'Kapasitas',
          subtitle: 'Cocok untuk anda yang memiliki keluarga, teman, atau sahabat dekat yang ingin bepergian dengan kapasitas 9 – 13 orang.'
        },
        {
          icon: 'tarif-pasti.png',
          icon_position: 'right',
          title: 'Tarif Pasti',
          subtitle: 'Kami memberikan tarif pasti kepada setiap Member STARGUIDES dan tidak perlu khawatir tawar menawar lagi karna biaya nya sudah pasti.'
        },
        {
          icon: 'friendly.png',
          icon_position: 'left',
          title: 'Friendly',
          subtitle: 'Guiders kami akan selalu memberikan pelayanan dan sikap yang terbaik bagi semua member STARGUIDES.'
        },
        {
          icon: 'aman-nyaman.png',
          icon_position: 'right',
          title: 'Aman dan Nyaman',
          subtitle: 'Guiders kami akan selalu berusaha untuk memberikan keamanan dan kenyamanan selama bepergian di kota yang anda kunjungi dengan STARGROUP.'
        },
        {
          icon: 'kemudahan-pembayaran.png',
          icon_position: 'left',
          title: 'Kemudahan Pembayaran',
          subtitle: 'Tidak perlu khawatir soal uang kembalian atau uang tunai, dengan, kartu kredit, layanan kami kini semakin praktis.'
        }
      ],
      stargroup_tariffs: [
        'Rp. 2.241.792* per hari (Eropa, Turki, Jepang, Korea, Tiongkok)',
        'Rp. 587.250* per hari (Malaysia)'
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Service/StarGroup.vue